// commercial classification
export const USER_TYPE = {
  INTERNAL_RESELLER: 1,
  EXTERNAL_RESELLER: 2,
};

// access level
export const USER_ROLE = {
  SUPER_ADMIN: 1,
  RESELLER_ADMIN: 2,
  RESELLER_USER: 3,
  OPERATOR: 4,
  INTERNAL_USER: 5,
  CATEGORY_MANAGER: 6,
  RESELLER_VISITOR: 8,
};
